import { takeLatest, takeEvery } from 'redux-saga/effects';

import {
  getAppConfigSaga,
  getProductCurrencySaga,
  getAppOptionsSaga,
  getCustomMenuItemsSaga,
  getUserPointsSaga,
  patchUserConditionsAndTermsSaga,
  getFeatureByNameSaga,
} from 'sagas/app.saga';
import {
  APP_CONFIG,
  PRODUCT_CURRENCY,
  GET_CUSTOM_MENU_ITEMS_ACTION,
  APP_OPTIONS,
  USER_POINTS,
  UPDATE_USER_CONDITIONS_AND_TERMS,
  FEATURE_BY_NAME,
} from 'actions/app.actions';
import { REQUEST } from 'services/api';

export function* getAppConfigSagaWatcher(): Generator<any> {
  yield takeLatest(APP_CONFIG[REQUEST], getAppConfigSaga);
}

export function* getProductCurrencySagaWatcher(): Generator<any> {
  yield takeLatest(PRODUCT_CURRENCY[REQUEST], getProductCurrencySaga);
}

export function* getAppOptionsSagaWatcher(): Generator<any> {
  yield takeLatest(APP_OPTIONS[REQUEST], getAppOptionsSaga);
}

export function* getCustomMenuItemsSagaWatcher(): Generator<any> {
  yield takeLatest(
    GET_CUSTOM_MENU_ITEMS_ACTION[REQUEST],
    getCustomMenuItemsSaga,
  );
}

export function* getUserPointsSagaWatcher(): Generator<any> {
  yield takeLatest(USER_POINTS[REQUEST], getUserPointsSaga);
}

export function* patchUserCGUSagaWatcher(): Generator<any> {
  yield takeLatest(
    UPDATE_USER_CONDITIONS_AND_TERMS[REQUEST],
    patchUserConditionsAndTermsSaga,
  );
}

export function* getFeatureByNameSagaWatcher(): Generator<any> {
  yield takeEvery(FEATURE_BY_NAME[REQUEST], getFeatureByNameSaga);
}
